import { Warning } from "../../../utils/models/input.interface"

/** * FU - 001 - Retorna a propriedade do status *
 *
 * @param {Warning} warning - obj com a lista de status.
 * @returns {string} propriedade do status *
 * @throws {  } null.
 *
 * @example
 * const warning: Warning = {
 *  sucess: { active: true, text: 'success' },
 *  error: null,
 *  info: null,
 *  alert: null,
 *  load: null
 * }
 * const result = propertyObjWarning(warning)
 * result é igual a 'sucess'
 **/
export function propertyObjWarning(warning: Warning): string {
  let propertyWarning = 'default';
  if(warning.status === 'success'){
    propertyWarning = 'sucess';
  } else if(warning.status === 'error'){
    propertyWarning = 'error';
  } else if(warning.status === 'info'){
    propertyWarning = 'info';
  } else if(warning.status === 'alert'){
    propertyWarning = 'alert';
  } else if(warning.status === 'loading'){
    propertyWarning = 'loading';
  }
  return propertyWarning;
}

/** * FU - 002 - Retorna o item pelo status especifico *
 *
 * @param {Warning} warning - obj com a lista de status.
 * @returns {string} Retorna o icone em que o status está inserido *
 * @throws {  } null.
 *
 * @example
 * const warning: Warning = {
 *  sucess: { active: true, text: 'success' },
 *  error: null,
 *  info: null,
 *  alert: null,
 *  load: null
 * }
 * const result = returnWarningIcon(warning)
 * result é igual a 'warning-sucess'
 **/
export function returnWarningIcon(warning: Warning): string {
  const porpertyIcon = propertyObjWarning(warning);
  const iconsWarning = {
    sucess: 'warning-sucess',
    error: 'warning-error',
    info: 'warning-circle-information',
    alert: 'warning-circle-alert',
    load: 'loading',
  };
  return iconsWarning[porpertyIcon] ? iconsWarning[porpertyIcon] : '';
}

/** * FU - 003 - Retorna a cor do texto da mensagem de erro *
 *
 * @param {Warning} warning - obj com a lista de status.
 * @returns {string} Retorna a cor em que o status está inserido *
 * @throws {  } null.
 *
 * @example
 * const warning: Warning = {
 *  sucess: { active: true, text: 'success' },
 *  error: null,
 *  info: null,
 *  alert: null,
 *  load: null
 * }
 * const result = returnColorWarning(warning)
 * result é igual a { 'color': '#115F22' }
 **/
export function returnColorWarning(warning: Warning): object {
  const porpertyIcon = propertyObjWarning(warning);
  const warningColors = {
    sucess: { 'color': '#115F22' },
    error: { 'color': '#A80B00' },
    info: { 'color': '#1F52AB' },
    alert: { 'color': '#5F4407' },
    load: { 'color': '#102956' },
  };
  return warningColors[porpertyIcon] ? warningColors[porpertyIcon] : {};
}

/** * FU - 004 - Retorna o texto pelo status especifico *
 *
 * @param {Warning} warning - obj com a lista de status.
 * @returns {string} Retorna o texto em que o status está inserido *
 * @throws {  } null.
 *
 * @example
 * const warning: Warning = {
 *  sucess: { active: true, text: 'success' },
 *  error: null,
 *  info: null,
 *  alert: null,
 *  load: null
 * }
 * const result = returnTextWarning(warning)
 * result é igual a 'success'
 **/
export function returnTextWarning(warning: Warning): string {
  return warning.text;
}

export function heightSidenavMenu(): void {
  setTimeout(() => {
    const menusHeight = document.querySelectorAll('.js_heigth_menu_container'), navlist: any = document.querySelector('.js_navlist_menu_container');
    if (menusHeight && navlist) {
      let heightMenu = 0;
      menusHeight.forEach((item: any) => {
        heightMenu += item.clientHeight;
      })
      navlist.style.maxHeight = `calc(100vh - ${heightMenu + 40}px)`;
    }
  }, 300);
}

export function squareTooltip(color: string): string {
  return `<span style="color: ${color}">◼</span>`;
}

export function paddingTooltip(size: number = 1): string {
  return `<span style="color: transparent">${'a'.repeat(size)}</span>`;
}

export function lineTooltip(size: number = 1, dash = false): string {
  return `${(dash ? '-' : '_').repeat(size)}`;
}
